import { RefObject, useEffect } from 'react';

export function useClickOutside(ref: RefObject<Element>, onClick: (event: MouseEvent) => void, triggerClass: string) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        ref.current &&
        !ref.current.contains(event.target as Element) &&
        !(event.target as HTMLElement).classList.contains(triggerClass)
      ) {
        onClick(event);
      }
    };

    // Bind the event listener
    document.addEventListener('click', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside);
    };
  });
}
